import React, { Component } from "react";
import { scoreValidation } from "../../assets/Js/scoreValidation";
import style from "./AddScore.module.css";

export default class CustomWeight extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue :''
        }
    }
    componentDidMount(){
        if(this.props.editable){
            this.setNewState();
        }
    }
    componentDidUpdate(prevprops){
        if(prevprops.editable !== this.props.editable){
            this.setNewState();
        }
    }
    setNewState(){
        this.setState({
            inputValue : this.props.values
        });
    }
    handleChange(value){
        let newValue = value;
        if(value === ''){
            newValue = '0';   
        }
        this.setState({
            inputValue:newValue
        })
        this.props.handleChange(newValue, this.props.index);
        return;
    }
    render(){
        return(
            <div>
              <input
                type="number"
                min="0"
                placeholder={this.props.placeholder}
                className={`form-control mt-2 rounded ${style.scoreTypeInput} tertiaryColor textAlignCenter `}
                value={this.state.inputValue || ''}
                onChange={(e) =>{this.handleChange(e.target.value)}}
              />
            </div>
        );
    }
}
